import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context as DeliveryContext } from '../../context/delivery';
import MainLayout from '../../layouts/mainLayout';
import TopBar from '../../layouts/delivery/topBar';
import SuccessPayment from '../../features/payments/successPayment';
import Loader from '../../components/misc/loader';
import FailPayment from '../../features/payments/failPayment';
import { usePaymentHandler } from '../../hooks/usePaymentHandler';
import { useDeliveryPageInit } from '../../hooks/useDeliveryPageInit';
import ContentWrapper from '../../layouts/delivery/contentWrapper';

const PaymentDeliveryPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { state: deliveryState } = useContext(DeliveryContext);

  const { isLoadingDeliveryInit, isSelectedRestaurantInit, selectedRestaurant } =
    useDeliveryPageInit();

  const canStartProcessingPayment =
    !isLoadingDeliveryInit && isSelectedRestaurantInit && !!selectedRestaurant;

  const { isCanceled, isSuccess, isLoading, isProcessing, paymentData } = usePaymentHandler({
    isDelivery: true,
    deliveryRestaurantId: selectedRestaurant ? selectedRestaurant.id : null,
    holdProcessing: !canStartProcessingPayment,
  });

  useEffect(() => {
    if (!canStartProcessingPayment) {
      return;
    }

    // Cancelled payment
    if (isCanceled) {
      navigate(`/${deliveryState.slug}/${selectedRestaurant.slug}`, { replace: true });
    }
  }, [canStartProcessingPayment]);

  if (isLoadingDeliveryInit || !isSelectedRestaurantInit || !selectedRestaurant) {
    return <Loader />;
  }

  // Cancelled payment
  if (isCanceled) {
    return null;
  }

  return (
    <MainLayout>
      <TopBar
        customTitle={t('header.payment')}
        onBack={() => {
          navigate(`/${deliveryState.slug}/${selectedRestaurant.slug}`);
        }}
      />
      {(isLoading || isProcessing) && (
        <div className="pt-32 pb-28">
          <Loader customHeight text={t('checkout.processingPaymentLoader')} />
        </div>
      )}
      {!isLoading && !isProcessing && !paymentData && (
        <ContentWrapper>
          <div className="mt-6 ">
            <div className="font-primaryMedium text-lg text-primary">{t('errors.noPayment')}</div>
          </div>
        </ContentWrapper>
      )}

      {isSuccess && paymentData && paymentData.processed && (
        <ContentWrapper>
          <div className="py-6 ">
            <SuccessPayment
              payment={paymentData}
              canRate={false}
              isDelivery
              onDeliveryPress={() => {
                navigate(`/${deliveryState.slug}/${selectedRestaurant.slug}`);
              }}
            />
          </div>
        </ContentWrapper>
      )}
      {(!isSuccess || (paymentData && paymentData.processingFailed)) && (
        <ContentWrapper>
          <FailPayment
            payment={paymentData}
            isDelivery
            onDeliveryPress={() => {
              navigate(`/${deliveryState.slug}/${selectedRestaurant.slug}`);
            }}
          />
        </ContentWrapper>
      )}
    </MainLayout>
  );
};

export default PaymentDeliveryPage;
